"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderOrderStatus = void 0;
const renderOrderStatus = (status) => {
    let config = {
        color: "bg-blue",
        text_color: "text-white",
        text: "",
    };
    switch (status) {
        case "DRAFT":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text: "Draft",
            };
            break;
        case "QUOTE":
            config = {
                color: "bg-blue",
                text_color: "text-white",
                text: "Quote",
            };
            break;
        case "QUOTE_EXPIRED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text: "Quote (Expired)",
            };
            break;
        case "QUOTE_CANCELLED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text: "Quote (Cancelled)",
            };
            break;
        case "WAITING_FOR_DEPOSIT":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text: "Waiting for Deposit",
            };
            break;
        case "CONFIRMING_GOLF":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Confirming Golf",
            };
            break;
        case "CONFIRMING_ALL":
            config = {
                color: "bg-orange",
                text_color: "text-white",
                text: "Confirming All",
            };
            break;
        case "WAITING_FOR_BALANCE":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text: "Waiting for Balance",
            };
            break;
        case "WAITING_FOR_PAYMENT":
            config = {
                color: "bg-darkorange",
                text_color: "text-white",
                text: "Waiting for Payment",
            };
            break;
        case "PAYMENT_OVERDUE":
            config = {
                color: "bg-red",
                text_color: "text-white",
                text: "Payment Overdue",
            };
            break;
        case "CONFIRMED":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text: "In Progress",
            };
            break;
        case "COMPLETE":
            config = {
                color: "bg-green",
                text_color: "text-white",
                text: "Complete",
            };
            break;
        case "CANCELLED":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text: "Cancelled",
            };
            break;
        case "CANCELLED_UNPAID":
            config = {
                color: "bg-grey3",
                text_color: "text-black",
                text: "Cancelled (Unpaid)",
            };
            break;
    }
    return config;
};
exports.renderOrderStatus = renderOrderStatus;
